@if (submitted) {
	<div class="error-text">
		@if (errors?.required) {
			<div class="aut-required-error">{{ controlName }} is required</div>
		}
		@if (errors?.min) {
			<div class="aut-more-error">{{ controlName }} must be {{ errors?.min?.min }} or more</div>
		}
		@if (errors?.max) {
			<div class="aut-less-error">{{ controlName }} must be {{ errors?.max?.max }} or less</div>
		}
		@if (errors?.invalidCheckbox) {
			<div class="aut-invalid-checkbox-error">At least one selection is required.</div>
		}
		@if (errors?.verifyGrade) {
			<div class="aut-verify-grade-error">Verify Grade.</div>
		}
		@if (errors?.invalidTable) {
			<div class="aut-invalid-table-error">At least one selection is required in the table.</div>
		}
		@if (errors?.multipleCapOverrideRulesSelected) {
			<div class="aut-multiple-cap-override-rules-error">Please select only one override rule.</div>
		}
        @if (errors?.inputMatch) {
            <div class="aut-input-match-error">
                Your name should be typed exactly as it appears above
            </div>
        }
		<div>
			@switch (errors?.pattern?.requiredPattern) {
				@case (UI_CONSTANTS.PATTERNS.EMAIL.toString()) {
					<div class="aut-email-error">{{ controlName }} has incorrect email format</div>
				}
				@case (UI_CONSTANTS.PATTERNS.MULTIPLE_EMAIL.toString()) {
					<div class="aut-multiple-email-error">{{ controlName }} has incorrect email format</div>
				}
				@case (UI_CONSTANTS.PATTERNS.PASSWORD.toString()) {
					<div class="aut-password-error">{{ controlName }} has Incorrect password format</div>
				}
				@case (UI_CONSTANTS.PATTERNS.PHONE.toString()) {
					<div class="aut-phone-error">{{ controlName }} has Incorrect phone format</div>
				}
				@case (UI_CONSTANTS.PATTERNS.CURRENCY.toString()) {
					<div class="aut-currency-error">Enter a valid money amount for {{ controlName }}</div>
				}
				@case (UI_CONSTANTS.PATTERNS.EMAIL_OR_PHONE.toString()) {
					<div class="aut-phone-email-error">Incorrect phone or email format for {{ controlName }}</div>
				}
				@case (UI_CONSTANTS.PATTERNS.STUDENT_ID.toString()) {
					<div class="aut-student-id-error">Incorrect student ID format for {{ controlName }}</div>
				}
				@case (UI_CONSTANTS.PATTERNS.DECIMAL.toString()) {
					<div class="aut-decimal-error">Only two decimals allowed for {{ controlName }}</div>
				}
				@case (UI_CONSTANTS.PATTERNS.ALPHANUMERIC.toString()) {
					<div class="aut-alphanumeric-error">No special characters allowed for {{ controlName }}</div>
				}
				@case (UI_CONSTANTS.PATTERNS.CRM_ID.toString()) {
					<div class="aut-alphanumeric-with-dash-error">
						Only - is allowed as special characters for {{ controlName }}
					</div>
				}
				@case (UI_CONSTANTS.PATTERNS.ALPHANUMERIC_SPACES.toString()) {
					<div class="aut-alphanumeric-spaces-error">No special characters allowed for {{ controlName }}</div>
				}
				@case (UI_CONSTANTS.PATTERNS.COURSE_NAME.toString()) {
					<div class="aut-course-name-error">No special characters allowed for {{ controlName }}</div>
				}
				@case (UI_CONSTANTS.PATTERNS.ALPHABETICAL.toString()) {
					<div class="aut-alphabetical-error">No special characters allowed for {{ controlName }}</div>
				}
				@case (UI_CONSTANTS.PATTERNS.NUMERIC.toString()) {
					<div class="aut-numbers-error">Only numbers allowed</div>
				}
				@case (UI_CONSTANTS.PATTERNS.NUMERIC_ONE_DECIMAL_PLACE.toString()) {
					<div class="aut-numbers-error">Incorrect format for {{ controlName }}</div>
				}
				@case (UI_CONSTANTS.PATTERNS.LETTERS_ONLY.toString()) {
					<div class="aut-letters-error">Only letters allowed for {{ controlName }}</div>
				}
				@case (UI_CONSTANTS.PATTERNS.ALPHANUMERIC_WITH_FEW_SPECIAL_CHARS_ONLY.toString()) {
					<div class="aut-letters-error">Invalid Character for {{ controlName }}</div>
				}
				@case (UI_CONSTANTS.PATTERNS.DATE.toString()) {
					<div class="aut-date-error">Incorrect date format for {{ controlName }}</div>
				}
				@case (UI_CONSTANTS.PATTERNS.URL.toString()) {
					<div class="aut-url-error">Incorrect URL format for {{ controlName }}</div>
				}
				@case (UI_CONSTANTS.PATTERNS.URL_SUBDOMAIN.toString()) {
					<div class="aut-url-error">Incorrect URL subdomain format for {{ controlName }}</div>
				}
				@case (UI_CONSTANTS.PATTERNS.NUMERIC_INTEGERS.toString()) {
					<div class="aut-url-error">{{ controlName }} must be a whole number greater than zero.</div>
				}
				@case (UI_CONSTANTS.PATTERNS.ALPHANUMERIC_SPECIAL.toString()) {
					<ng-container [ngTemplateOutlet]="invalidChar"> </ng-container>
				}
				@case (UI_CONSTANTS.PATTERNS.ALPHANUMERIC_SPECIAL_COMMENT.toString()) {
					<ng-container [ngTemplateOutlet]="invalidChar"> </ng-container>
				}
				@case (UI_CONSTANTS.PATTERNS.ALPHANUMERIC_SPECIAL_WITH_POUND.toString()) {
					<ng-container [ngTemplateOutlet]="invalidChar"> </ng-container>
				}
				@case (UI_CONSTANTS.PATTERNS.TEXT_WITHOUT_HTML.toString()) {
					<div class="aut-url-error">No HTML Tags are allowed.</div>
				}
				@case (UI_CONSTANTS.PATTERNS.TWO_DECIMAL_PERCENTAGE.toString()) {
					<div class="aut-url-error">Invalid Percentage.</div>
				}
				@case (UI_CONSTANTS.PATTERNS.NUMERIC_GREATER_THAN_ZERO_TWO_DECIMAL_PLACES.toString()) {
					<div class="aut-numbers-error">Incorrect format for {{ controlName }}</div>
				}
				@case (UI_CONSTANTS.PATTERNS.NUMERIC_TWO_DECIMAL_PLACE.toString()) {
					<div class="aut-numbers-error">Incorrect format</div>
				}
				@case (UI_CONSTANTS.PATTERNS.FIELD_OF_STUDY.toString()) {
					<div>Invalid character or FOS must be 3 characters or more</div>
				}
			}
		</div>
		<ng-template #invalidChar>
			<div class="aut-url-error">Invalid character.</div>
		</ng-template>
		@if (errors) {
			<div>
				@for (customError of customErrors; track customError) {
					<div>
						@if (errors[customError.errorName]) {
							<div>
								{{ customError.errorMessage }}
							</div>
						}
					</div>
				}
			</div>
		}
	</div>
}
